<template>
  <div id="app" class="flux-container external-loop">
    <div v-if="hippoIsLoading">
      <i class="fa fa-spinner fa-spin fa-2x fa-fw" />
      Chargement...
    </div>
    <div v-if="!hippoIsLoading" class="hippo-header aio-cards-grid">
      <div class="aio-card">
        <div class="aio-card-main text-center">
        <div @contextmenu.prevent.stop="handleClick($event)"
             @click.prevent.stop="handleClick($event)"
             class="size icone-size cursor d-flex justify-content-end mb-3">
          <i class="fa fa-cog" aria-hidden="true"></i>
        </div>
          <h3>{{ displayRef(reference.reference.code) }}</h3>
          <div>{{reference.reference.designation }}</div>
          <div><b>{{reference.reference.supermarket_emplacement }}</b></div>
          <div class="mt-4 d-flex flex-column">
            <h2 class="mt-2">{{ steps['Attente commande'].from_previous_takt }}</h2>
            <small class="takt-time-conso mt-3"><b>Takt Time de consommation</b></small>
            <div class="flex xs12 mt-3">
              <b-badge pill variant="danger" v-if="andonLowStock">Low Stock</b-badge>
              <b-badge pill variant="danger" v-if="andonBadErpStock">Bad ERP</b-badge>
              <b-badge pill variant="danger" v-if="andonUnseen">Unseen Card</b-badge>
              <b-badge pill variant="danger" v-if="andonSpeed">{{andonSpeed}}</b-badge>
            </div>
            <div v-for="scan in sortedArray.slice(0, 1)" v-if="scan.andon_speed!='standard'" class="d-flex justify-content-around mt-1">
              <b-badge pill variant="danger">{{ scan.kanban_card.card_id }} {{ scan.andon_speed }}</b-badge>
            </div>
          </div>
        </div>
        <div class="aio-card-secondary">{{reference.nbr_card}} cartes de {{reference.batch_size}} unités</div>
      </div> 
    </div>
    <div v-if="!hippoIsLoading">
      <workstation-list
        :workstationList="steps"
        :bLlist="bLlist"
        :supplierList="supplierList"
        :andonLowStock="andonLowStock"
      />

      <vue-simple-context-menu
        :elementId="'context-menu-'"
        :options="contextMenuList"
        :ref="'vueSimpleContextMenu'"
        @option-clicked="optionClicked"
      />
    </div>
    <div class="row d-flex justify-content-between ml-1 mr-1">
      <div v-if="scans.length" class="workstation-list scan-list col-12 m-1 col-xl-5">
        <div class="kanban-card workstation-header m-1">
          <b v-if="scans.length === 1"> 1 scan en attente de commande</b>
          <b v-else-if="scans.length <= 10"> {{scans.length}} derniers scans en attente de commande</b>
          <b v-else>10 derniers scans en attente de commande</b>
        </div>
        <div class="kanban-card d-flex row workstation-header m-1">
          <div v-for="(scan, index) in sortedArray.slice(0, 10)" :key="index" class="d-flex row w-100 justify-content-between">
            <b-badge pill variant="light">{{ scan.kanban_card.card_id }}</b-badge>
            <span class="scan-date">{{scan.date}}</span>
            <b-badge pill variant="light">{{scan.andon_speed}}</b-badge>
          </div>
        </div>
      </div>
      <div v-if="cardsConsumed" class="workstation-list scan-list col-12 m-1 col-xl-5">
        <div class="kanban-card d-flex row workstation-header m-1">
          <p>10 dernières cartes consommées</p>
        </div>
        <div class="kanban-card d-flex row workstation-header m-1">     
          <div v-for="card in cardsConsumed" class="d-flex row w-100 justify-content-between"> 
            <b-badge pill variant="light">{{ card.cardIndex }} - {{ card.cardNum }}</b-badge>
            <span class="scan-date">{{ card.consumed_at }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import server from '../../../api/server.vue'
import { Steps } from '../../../core/services/steps.js'
import { Utils } from '../../../core/utils/utils.js'
import WorkstationList from '../hippodrome/WorkstationList.vue'
import moment from 'moment'
import VueSimpleContextMenu from 'vue-simple-context-menu'

export default {
  name: 'AndonReference',
  props: [],
  components: { WorkstationList},
  data () {
    return {
      kanban_id: '',
      reference: null,
      scans: [],
      cardsConsumed: [],
      bLlist: '',
      andonRotation: false,
      cardInStock: '?',
      stepList: Steps,
      workstationList: ['En Stock', 'Attente commande', 'Commandé'],
      andonLowStock: null,
      andonUnseen: null,
      //andonFifo: null,
      andonBadErpStock: null,
      andonSpeed: null,
      loaded: false,
      hippoIsLoading: true,
      steps: JSON.parse(JSON.stringify(Steps)),
      supplierList: [],
      statsDone: false,
      contextMenuList: [
        {
        name: '<i class="fa fa-refresh" aria-hidden="true"></i> Mettre à jour le produit',
        slug: 'update'
        },
        {
        name: '<i class="fa fa-ban" aria-hidden="true"></i> Desactiver le produit',
        slug: 'disable'
        },
        {
         type: 'divider'
        },
        {
        name: 'A',
        slug: 'A'
        },
        {
        name: 'B',
        slug: 'B'
        },
        {
        name: 'C',
        slug: 'C'
        },
        {
        name: 'D',
        slug: 'D'
        },
      ]
    }
  },
  methods: {
    displayDelay (since) {
      var now = moment()
      return now.diff(moment(since), 'days')
    },
    displayRef (reference) {
      return this.chunk(reference, 3)
    }, 
    singleFifoPromise (card_id) {
      return server.getFifoAndonFromCard(card_id).then(result => {
        return [card_id, result.data.andon]
      })
    },
    addFifoAndon (cards) {
      const promises = []
      for (const card_id in cards) {
        promises.push(this.singleFifoPromise(card_id))
      }
      return Promise.all(promises).then(values => {
        for (var item in values) {
          this.cards[values[item][0]].fifo = values[item][1]
        }
        return true
      })
    },
    singleUnseenPromise (card_id) {
      return server.getUnseenCardAndonFromCard(card_id).then(result => {
        return [card_id, result.data.andon]
      })
    },
    addUnseenCardAndon (cards) {
      const promises = []
      for (const card_id in cards) {
        promises.push(this.singleUnseenPromise(card_id))
      }
      return Promise.all(promises).then(values => {
        for (var item in values) {
          this.cards[values[item][0]].unseen_card = values[item][1]
        }
        return true
      })
    },
    getBlFromRef () {
      server.getAllBl(this.kanban_id).then(result => {
        this.bLlist = result.data
      })
    },
    computeSuppliersRatio (supplierOrderStat) {
      let totalOrder = 0
      Object.values(supplierOrderStat).forEach((value) => { totalOrder += value})
      Object.entries(supplierOrderStat).forEach(([supplierName, nb]) => {
        const ratio = `${Math.trunc(nb / totalOrder * 100)}%`
        const supplier = this.supplierList.find((el) => el.supplier.toLowerCase() === supplierName.toLowerCase())
        if (supplier) {
          supplier.ratio = ratio
        }
      })
    },
    addStdTime (cards) {
      if(_.isEmpty(this.reference) || _.isEmpty(this.reference.reference))
        return
      return server.getKanbanReferenceStats(this.reference.reference.code, 'loop_external').then(result => {
        const supplierOrderStat = result.data.suppliers_order_stat
        this.computeSuppliersRatio(supplierOrderStat)
        for (const step in result.data.stats) {
          if (step in this.steps) {
            if (step == "Commandé") {
              for (const [key, value] of Object.entries(result.data.stats[step])) {
                let nbDay = (value / 3600 / 24).toFixed(1)
                nbDay = isNaN(nbDay) ? '?' : nbDay + ' J'
                this.steps[step][key] = {'to_next_idle':  nbDay }
              }
            } else {
              let nbDay = (result.data.stats[step] / 3600 / 24).toFixed(1)
              nbDay = isNaN(nbDay) ? '?' : nbDay + ' J'
              this.steps[step].to_next_idle = nbDay
            }
          }
        }
        for (const step in result.data.takt_time) {
          if (step in this.steps) {
            if (step == "Commandé") {
                for (const [key, value] of Object.entries(result.data.takt_time[step])) {
                  let nbDay = (value / 3600 / 24).toFixed(1)
                  nbDay = isNaN(nbDay) ? '?' : nbDay + ' J'
                  this.steps[step][key].from_previous_takt = nbDay
                }
            } else {
              let nbDay = (result.data.takt_time[step] / 3600 / 24).toFixed(1)
              nbDay = isNaN(nbDay) ? '?' : nbDay + ' J'
              this.steps[step].from_previous_takt = nbDay
            }
          }
        }
        this.statsDone = true
        return true
      })
    },
    sortCardByStep (cards) {
      // this.steps = JSON.parse(JSON.stringify(Steps))
      for (const [key, value] of Object.entries(cards)) {
        if (value.last_scan && !_.isEmpty(value.last_scan)) {
          value.last_scan.created_for = this.displayDelay(
            value.last_scan.created_at
          )
        }
        if (
          value.last_scan &&
          !_.isEmpty(value.last_scan) &&
          value.last_scan.workstation.name &&
          !_.isEmpty(value.last_scan.workstation.name)
        ) {
          this.steps[value.last_scan.workstation.name].cards.push(value)
        } else {
          this.steps['En Stock'].cards.push(value)
        }
      }
      for (var step in this.steps) {
        this.steps[step].cards.sort((a, b) => {
          if (_.isEmpty(a.last_scan) || _.isEmpty(b.last_scan)) {
            return -1
          }
          if (a.last_scan.created_for < b.last_scan.created_for){
            // Right order
            return 1
          }
          if (a.last_scan.created_for > b.last_scan.created_for){
            // Wrong order -> inverse
            return -1
          }
          // Same scan date -> First index first
          return (a.card_index > b.card_index ? 1 : -1)
        })
      }
    },
    getReferenceSuppliers (cards) {
        for (const [key, value] of Object.entries(cards)) {
            if (!this.supplierList.some(el => el.supplier === value.supplier.supplier)) {
                this.supplierList.push(value.supplier)
            }
        }
    },
    getReferenceAndonsLastScans (cards) {
      for (const [key, value] of Object.entries(cards)) {
        server.getScanAndon(key).then(scan => {
          for (const [key, value] of Object.entries(scan.data)) {
            if (key === 0 && value.andon_speed != "standard") {
              this.andonSpeed = value.andon_speed
            }
            value.date = moment(value.created_at)
                .locale('FR')
                .format('Do MMM YY, kk:mm')
            if (value.workstation.name == 'Attente commande') {
              
              this.scans.push(value)
            }
          }
        })
      }
    },
    optionClicked (event) {
          const option = event.option.slug
          const document = event.item
          if (option === 'update') {
            this.moveToUpdateView(document)
          } else if (option === 'disable') {
            this.disable(document)
          } else if (option === 'details') {
            this.changeRanking('A', document)
          }  else if (option === 'B') {
            this.chBngeRanking('B', document)
          }  else if (option === 'C') {
            this.changeRanking('C', document)
          }  else if (option === 'D') {
            this.changeRanking('D', document)
          }
    },
    handleClick (event) {
      this.$refs.vueSimpleContextMenu.showMenu(event, this.reference.reference.code)
    },
    moveToUpdateView(document) {
      this.goTo('/references/new/' + document)
    },
    changeRanking (ranking, document) {
      const ref_id = this.reference.reference.uniqid
      server.changeReferenceRanking(ref_id ,ranking).then(() => {
      })
    },
    disable(document) {
      referenceApi.removeReference(this.reference.reference.code).then(result => {
        this.reference.removed = 'Supprimé'
        this.reference.loops = []
      })
    },
    showDetail(document) {
      server.getKanbanCardByReference(this.reference.reference.code, 'loop_external')
      .then(response => {
        this.detailsItems = response.data
        for (let index = 0; index < this.detailsItems.length; index++) {
          if(this.detailsItems[index].card_index === -1){
            this.detailsItems[index]._rowVariant  = 'warning'
          }
        }
        this.totalDetailsRows = this.detailsItems.length
        if ( this.previousRowDetailed && row.item.reference.code != this.previousRowDetailed.item.reference.code) {
          this.previousRowDetailed.toggleDetails()
        }
        row.toggleDetails()
      })
    },
    getLastCartConsumed(reference) {
      server.getLastCardConsumed(reference).then((response) => {
        let data = response.data
        let index = ''
        data.forEach((result) => {
            let date = moment(result.created_at)
                .locale('FR')
                .format('Do MMM YY, kk:mm')
            if (result.kanban_card.card_index > 0) {
              index = 'N°' + result.kanban_card.card_index  
            } else {
              index = 'TMP'
            }   
            let dataCard = {
              'cardNum': result.kanban_card.card_id,
              'cardIndex': index, 
              'consumed_at': date}
            this.cardsConsumed.push(dataCard)  
        })
      })
    }
  },
  computed: {
    getAndons () {
      var andons = this.$store.getters.getAndons
      if (andons.length > 0) {
        return andons
      }
      return []
    },
    sortedArray: function() {
      function compare(a, b) {
        if (a.created_at > b.created_at)
          return -1;
        if (a.created_at < b.created_at)
          return 1;
        return 0;
      }
      return this.scans.sort(compare);
    }
  },
  mounted: function () {
    for (var key in this.steps) {
      this.steps[key].cards = []
    }
    this.kanban_id = this.$route.params.reference.toUpperCase()
    server
      .getKanbanReferenceInfosByKanbanReference(this.kanban_id, 'loop_external')
      .then(result => {
        this.reference = result.data
        this.reference.emplacement =
          this.reference.zone +
          this.reference.pos_y +
          Utils.pad(this.reference.pos_x) +
          this.reference.pos_z
        this.andonRotation =
          parseFloat(this.reference.rotation) < 10
          server.getAndonLowStockForRef(this.kanban_id).then(result => {
          this.andonLowStock = result.data.andon.length > 0 ? result.data.andon[0] : null
        })
       /* server.getAndonFifoForRef(this.kanban_id).then(result => {
          this.andonFifo = result.data.andon.length > 0 ? result.data.andon[0] : null
        }) */
        server.getAndonBadErpStockForRef(this.kanban_id).then(result => {
          
          this.andonBadErpStock = result.data.andon.length > 0 ? result.data.andon[0] : null
        })
        server.getAndonUnseenCardForRef(this.kanban_id).then(result => {
          this.andonUnseen = result.data.andon.length > 0 ? result.data.andon[0] : null
        })
      })
    server.getCardFromReference(this.kanban_id, 'loop_external').then(result => {
      this.cards = result.data.cards
      this.getReferenceSuppliers(this.cards)
      this.addFifoAndon(this.cards)
        .then(() => this.addUnseenCardAndon(this.cards))
        .then(() => this.addStdTime(this.cards))
        .then(() => {
          this.sortCardByStep(this.cards)
          this.loaded = true
          this.hippoIsLoading = false
          this.getReferenceAndonsLastScans(this.cards)
          this.$forceUpdate()
        })
      //
    })
    this.getLastCartConsumed(this.kanban_id)
    this.getBlFromRef()
  },
// eslint-disable-next-line
};
</script>
<style>
.external-loop.flux-container {
  font-size: 0.7em;
  color: #242424;
}

@media (min-width: 992px) {
  .external-loop.flux-container{
    font-size: 1em;
  }
}

.external-loop .hippo-header {
  background-color: var(--a-light-grey);
}

.external-loop .aio-cards-grid {
  display: flex;
  justify-content: center;
}

.external-loop .aio-card {
  width: fit-content;
  font-size: 0.8em;
}

.external-loop .workstation-list {
  margin-top: 0;
  border-top-right-radius: 0;
  border-top-left-radius: 0;

}

.external-loop .takt-time-conso {
  display: inline-block;
  transform: translateY(-20px);
}

.scan-list {
  padding: 1.6em 1em 1em;
  display: flex;
  flex-direction: column;
  margin: auto;
}

.scan-date {
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/andon/detailed/andon_reference.vue